import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { ActualizarInformacionBeneficiariosComponent } from './ActualizarInformacionBeneficiarios.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'ActualizarInformacionBeneficiarios',
        component: ActualizarInformacionBeneficiariosComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ActualizarInformacionBeneficiarios',
          nombreFormulario : 'Cargue Archivo Actualizar Información Beneficiarios'
        } 
    }
];


@NgModule({
    declarations: [
        ActualizarInformacionBeneficiariosComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ActualizarInformacionBeneficiariosComponent
    ],
    bootstrap: [ActualizarInformacionBeneficiariosComponent]
})

export class ActualizarInformacionBeneficiariosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ActualizarInformacionBeneficiarios/ActualizarInformacionBeneficiarios.module.ts